import styled from 'styled-components'

export const ExpirationList = styled.div`
  display: grid;
  width: 100%;

  border-radius: 2px;
  border: 1px solid ${({ theme }) => `rgb(${theme.component.accent})`};

  ul {
    display: grid;

    margin: 0;
    padding: 0;
    list-style: none;

    max-height: 75vh;

    overflow: auto;
  }

  .listHeader {
    display: grid;
    align-items: center;
    background: ${({ theme }) => `rgb(${theme.component.accent})`};

    grid-template-columns: 2fr 1fr 1fr 1fr;

    font-size: 0.875rem;
    font-weight: 700;
    color: ${({ theme }) => `rgb(${theme.grayscale[100]})`};

    span {
      text-align: center;
      padding: 0.5625rem 0.5rem;
    }

    @media screen and (min-width: 590px) {
      padding: 0.5625rem 1rem;
    }

    span:first-child {
      text-align: start;
    }
  }

  .listRow {
    display: grid;
    grid-template-columns: 2fr 1fr 1fr 1fr;

    margin-left: 1rem;
    border-bottom: 1px solid ${({ theme }) => `rgb(${theme.component.accent})`};

    &:last-child {
      border-bottom: none;
    }

    .listContent {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 0.5rem;

      text-align: center;
      padding: 1rem 0.5rem;

      font-size: 0.875rem;
      font-weight: 400;
      color: ${({ theme }) => `rgba(${theme.grayscale[100]}, 0.9)`};

      overflow: hidden;
      text-overflow: ellipsis;

      @media screen and (min-width: 590px) {
        padding: 1rem;
        gap: 1rem;
      }
    }

    .listContent:first-child {
      text-align: start;
      font-weight: 500;
      justify-content: flex-start;
    }

    .listIcon {
      flex-shrink: 0;

      margin: 0;
      padding: 0;

      width: 2.5rem;
      height: 2.5rem;

      img {
        width: 100%;
        height: 100%;

        background-color: #fff;
        border-radius: 5px;

        object-fit: contain;
      }
    }
  }

  .noOrdersRow {
    padding: 2rem 1rem;
    text-align: center;

    font-weight: 500;
    color: ${({ theme }) => `rgba(${theme.grayscale[100]}, 0.9)`};
  }
`
